// extracted by mini-css-extract-plugin
module.exports = {"label":"styles__label___3OAs0","required":"styles__required___1zL1I","description":"styles__description___3_UpI","adminIcon":"styles__adminIcon___tVh8b"};